import { assign, literal, object, string } from "superstruct";

import InstagramBaseStorySchema from "./InstagramBaseStorySchema";

const InstagramVideoStorySchema = assign(
    InstagramBaseStorySchema,
    object({
        mediaType: literal("video"),
        videoUrl: string(),
    })
);

export default InstagramVideoStorySchema;
